import { render, staticRenderFns } from "./FollowBtn.vue?vue&type=template&id=cd116fc2&scoped=true&"
import script from "./FollowBtn.vue?vue&type=script&lang=js&"
export * from "./FollowBtn.vue?vue&type=script&lang=js&"
import style0 from "./FollowBtn.vue?vue&type=style&index=0&id=cd116fc2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd116fc2",
  null
  
)

export default component.exports